import { z } from '@harvestiq/zod';
import { UserRoles } from './user-roles';

export const addUserRoleRequestParamsSchema = z.object({
  userId: z.string().uuid(),
});

export const addUserRoleRequestBodySchema = z.object({
  roleId: z.nativeEnum(UserRoles),
});
